<template>
  <div class="details" id="details">
    <div class="details-title">
      <span v-html="content.title"></span>
      <p v-html="content.subtitle"></p>
    </div>
    <div class="details-overlay">
      <div class="details-overlay-cover" v-for="(item,index) in content.slides" :key="index">
        <div class="details-overlay-item">
          <div class="details-overlay-img">
            <div class="youtube">
              <div class="youtube-overlay" @click="openVideo(item)">
                <img :src="item.youtube.poster" :alt="item.youtube.poster">
                <svg width="124" height="124" viewBox="0 0 124 124" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="62" cy="62" r="61" stroke="white" stroke-width="2"/>
                  <path d="M80 62.5L53 79L53 46L80 62.5Z" fill="white"/>
                </svg>
              </div>
            </div>
          </div>
          <div class="details-overlay-content">
            <span class="details-overlay-content-title" v-html="item.title"></span>
            <b class="details-overlay-content-bold" v-html="item.title_bold"></b>
            <p class="details-overlay-content-subtitle" v-html="item.subtitle"></p>
            <p class="details-overlay-content-excerpt" v-html="item.excerpt">
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {bus} from "../../utils/bus";

export default {
  name: "Details",
  props: ['content'],
  components: {},
  methods: {
    openVideo(item) {
      bus.$emit('open-video', item.youtube.youtubeId)
    }
  }
}
</script>

<style scoped lang="scss">
@import "details";
</style>
